import { fetchFinance } from "utils/api";
import { getAgent } from "utils/utils";

export const queryList = async (params) => {
  return await fetchFinance("/action", {
    action: "getDebitApply",
    debitStatus: "APPROVED",
    sort: "created,desc",
    ...params,
  });
};

export const rejectDebitNotes = async (params) => {
  const agent = getAgent();
  return await fetchFinance("/action", {
    debitStatus: "REJECTED",
    action: "approveDebitApply",
    reviewer: agent.email,
    ...params,
  });
};
